import { Button } from "antd";
import React  from "react";
interface AddSponsorButtonProps {
  title: string;
  onClick?: () => void;
  icon?: React.ReactNode;
}
const AddSponsorButton = ({ icon, title,...props }: AddSponsorButtonProps) => {
  return (
    <Button {...props} className="takaful--add-sponsor-button" icon={icon}>
      {title}
    </Button>
  );
};

export default AddSponsorButton;
